export const PRODUCT_DETAILS = "product details"
export const WISHLIST_SAVE = "wishlist save"
export const WISHLIST_DELETE = "wishlist delete"
export const SELECT_MY_LIST = "select my list"
export const CLOSE = "close"
export const SAVE_TO_LIST = "save to list"
export const SAVE_TO_LIST_GUEST = "save to list guest"
